<template>
  <div>
    <v-app-bar absolute id="app-bar" color="#81C0E2" style="height: 64px" elevate-on-scroll scroll-target="#scrolling-techniques-7">
      <div class="d-inline-block" style="width:160px">
        <v-img :src="images.new_logo" width=280 alt="中華企業資源規劃學會LOGO"></v-img>
      </div>
    </v-app-bar>
    <v-row style="height:64px; width:100%">
    </v-row>
    <v-row class="ma-5" style="height:40px;">
      <!-- <v-btn  class="ma-0 pa-0" outlined style="width:130px; height:40px; background:#FFF; border-radius:8px; border: 1px solid #969698" @click="redirectPath('/login')">
        <v-icon style="color:#969698">mdi-arrow-left-bold-circle-outline</v-icon>
        <span class="px-1" style="font-size:13pt; color:#969698">回登入頁</span>
      </v-btn> -->
    </v-row>
    <v-card color="#FFF" style="box-shadow:none; overflow-x:hidden; overflow-y:scroll" align="center" :style="viewStyle">
      <v-row class="ma-0" justify="center">
        <v-col class="pb-0 col-10 col-sm-9 col-md-8 col-lg-5" align="right">
          <div id="box2" class="my-2 pa-5 py-10" style="min-height:460px">
            <v-row justify="center" class="my-5">
              <h1>考試連結下載</h1>
            </v-row>
            
            <v-expansion-panels accordion style="z-index: initial">
              <v-expansion-panel v-for="(menu,i) in menus" :key="i">
                <v-expansion-panel-header @click="selectMenu(menu)"
                  :class="{ selectedMenu: menu.name==currentMenuName }">
                  <h2 class="col-4 pa-0 pl-2">
                    {{menu.name}}
                  </h2>
                  <template v-slot:actions>
                    <v-icon :color="(menu.name==currentMenuName)?'#FFF':'#000'">$expand</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <!-- <v-row v-if="currentMenuName=='WindowsLink'" class="my-3 pa-0 ma-0" justify="center">
                    <v-col cols="11" class="ma-0 pa-0 text-left">
                      <h4 class="ma-0 pa-0">1.<a style="font-size:26px; color:#215DA7" @click="downloadLink()">下載安裝檔案</a></h4>
                      <h4 class="ma-0 pa-0">2.點擊已下載的項目(CERPS專業認證考試.vbs)</h4>
                      <h4 class="ma-0 pa-0">3.系統「開啟檔案-安全性警告」提示時，點擊「開啟」</h4>
                      <v-img :src="images.windowsLink1" contain height="260" alt="系統公告"></v-img>
                      <h3 class="ma-0 pa-0 mt-5 mb-2" style="color:#FF5656">注意事項</h3>
                      <h4 class="ma-0 pa-0">*如下載考試系統不成功，請來信附上截圖詢問</h4>
                      <h4 class="ma-0 pa-0">*考試過程須確保網路順暢，避免影響您的權益，若有任何疑問請即時聯繫學會人員</h4>
                    </v-col>
                  </v-row> -->
                  <v-row v-if="currentMenuName=='Windows'" class="my-3 pa-0 ma-0" justify="center">
                    <v-col cols="11" class="ma-0 pa-0 text-left">
                      <h4 class="ma-0 pa-0">1.<a style="font-size:26px; color:#215DA7" @click="downloadWindows()">下載安裝檔案</a></h4>
                      <h4 class="ma-0 pa-0">2.點擊已下載的項目(雙擊開啟遠距考試工具.exe)</h4>
                      <h4 class="ma-0 pa-0">3.系統「Windows已保護您的電腦」提示時，點擊「其他資訊」，再點擊「仍要執行」</h4>
                      <v-img :src="images.windows1" contain height="260" alt="系統公告"></v-img>
                      <h3 class="ma-0 pa-0 mt-5 mb-2" style="color:#FF5656">常見問題排除</h3>
                      <h4 class="ma-0 pa-0">如果遠距考試工具開啟後超過一分鐘仍無考試系統畫面</h4>
                      <v-img :src="images.problem0" contain height="240" alt="常見問題排除0"></v-img>
                      <h4 class="ma-0 pa-0">請依下述步驟進行相容性問題排除：</h4>
                      <h4 class="ma-0 pa-0">第一步：請點選系統右上角「關閉考試工具」按鈕，關閉系統</h4>
                      <v-img :src="images.problem1" contain height="260" alt="常見問題排除1"></v-img>
                      <h4 class="ma-0 pa-0">第二步：選取「遠距考試工具.exe」，點擊滑鼠右鍵-內容</h4>
                      <v-img :src="images.problem2" contain height="260" alt="常見問題排除2"></v-img>
                      <h4 class="ma-0 pa-0">第三步：於相容性頁籤，將「以相容模式執行這個程式」框框打勾後，點選確定</h4>
                      <v-img :src="images.problem3" contain height="260" alt="常見問題排除3"></v-img>
                      <h4 class="ma-0 pa-0">第四步：重新進入遠距考試工具畫面能正常顯示(此畫面為正常顯示畫面)</h4>
                      <v-img :src="images.problem4" contain height="260" alt="常見問題排除4"></v-img>
                      <h3 class="ma-0 pa-0 mt-5 mb-2" style="color:#FF5656">注意事項</h3>
                      <h4 class="ma-0 pa-0">*如下載考試系統不成功，請來信附上截圖詢問</h4>
                      <h4 class="ma-0 pa-0">*考試過程須確保網路順暢，避免影響您的權益，若有任何疑問請即時聯繫學會人員</h4>
                    </v-col>
                  </v-row>
                  <v-row v-if="currentMenuName=='Mac'" class="my-3 pa-0 ma-0" justify="center">
                    <v-col cols="11" class="ma-0 pa-0 text-left">
                      <h4 class="ma-0 pa-0">1.<a style="font-size:26px; color:#215DA7" @click="downloadMac()">下載安裝檔案</a></h4>
                      <h4 class="ma-0 pa-0">2.點擊已下載的項目(新版遠距考試工具.dmg)</h4>
                      <h4 class="ma-0 pa-0">3.若被阻擋請點選仍要下載->下載完 dmg 檔後->打開 dmg 檔->會出現下列畫面->請將 Certification 拖拉到 Applications</h4>
                      <v-img :src="images.demo" contain height="260" alt="系統公告"></v-img>
                      
                      <h3 class="ma-0 pa-0 mt-5 mb-2" style="color:#FF5656">常見問題排除</h3>
                      <h4 class="ma-0 pa-0">由於 macOS 啟用了新的安全機制，可能有新系統警示</h4>
                      <h4 class="ma-0 pa-0">系統警示 1:若系統提示打不開，因為它來自身份不明的開發者</h4>
                      <h4 class="ma-0 pa-0">系統警示 2:若系統提示打不開，因為 Apple 無法檢查其是否包含惡意軟體</h4>
                      <v-img :src="images.mac1" contain height="240" alt="系統公告"></v-img>
                      
                      <h4 class="ma-0 pa-0">解法1:需要在 [系統偏好設置->安全性與隱私->一般] 中手動開啟 [任何來源] 選項 或 [強制打開] 選項</h4>
                      <v-img :src="images.mac2" contain height="260" alt="系統公告"></v-img>
                      <h4 class="ma-0 pa-0">解法2:若無此選項，則以文字搜尋 [Terminal App]，輸入 [sudo spctl --master-disable] 後點選 [Enter] 鍵，重新開啟 App 即可</h4>
                      
                      <h3 class="ma-0 pa-0 mt-5 mb-2" style="color:#FF5656">注意事項</h3>
                      <h4 class="ma-0 pa-0">*如下載考試系統不成功，請來信附上截圖詢問</h4>
                      <h4 class="ma-0 pa-0">*考試過程須確保網路順暢，避免影響您的權益，若有任何疑問請即時聯繫學會人員</h4>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <!-- <v-row style="margin-top:3%; margin-left:3%">
              <div class="mx-5 firstBar"></div>
              <h4 style="font-size:26px">考試連結下載-Windows</h4>
            </v-row>
            <v-row style="height:100px" justify="center">
              <v-col class="col-9 col-sm-9 col-md-8 col-lg-8">
                <v-row class="mt-2" align="center" style="height:100%">
                  <div class="loginBtn centerBtn" style="height:60%; width:100%; cursor: pointer" @click="downloadLink()">
                    <h4 style="color:#FFFFFF">點此下載</h4>
                  </div>
                </v-row> 
              </v-col>
            </v-row>
            <v-row style="margin-top:3%; margin-left:3%">
              <div class="mx-5 firstBar"></div>
              <h4 style="font-size:26px">考試連結下載-Macbook</h4>
            </v-row>
            <v-row style="height:100px" justify="center">
              <v-col class="col-9 col-sm-9 col-md-8 col-lg-8">
                <v-row class="mt-2" align="center" style="height:100%">
                  <div class="loginBtn centerBtn" style="height:60%; width:100%; cursor: pointer" @click="downloadMac()">
                    <h4 style="color:#FFFFFF">點此下載</h4>
                  </div>
                </v-row> 
              </v-col>
            </v-row> -->
          </div>
        </v-col>
      </v-row>
      <div class="pt-3 pb-10 col-10">
        <h4 style="font-size:12px">中華企業資源規劃學會 版權所有，禁止未經授權轉貼節錄</h4>
        <h4 style="font-size:12px"> 2009 中華企業資源規劃學會．Chinese Enterprise Resource Planning Society.</h4>
        <h4 style="font-size:12px">校址：(32001)桃園市中壢區中大路300號 管理學院二館6F Tel：(03)426-4248 Fax：(03)426-0076</h4>
      </div>
    </v-card>
    <ShowMsg ref="ShowMsg" />
  </div>
</template>
<script>

import CryptoJS from "crypto-js"
import ShowMsg from '@/dialogs/ShowMsg'

export default {
  name: 'Download',
  components: {ShowMsg},
  data:()=>({
    viewStyle:{},
    images:{
      new_logo: require('@/assets/image/erp_logo.png'),
      demo: require('@/assets/image/demo.jpg'),
      windowsLink1: require('@/assets/image/windowsLink1.png'),
      windows1: require('@/assets/image/windows1.png'),
      mac1: require('@/assets/image/mac1.png'),
      mac2: require('@/assets/image/mac2.png'),
      problem0: require('@/assets/image/problem0.png'),
      problem1: require('@/assets/image/problem1.png'),
      problem2: require('@/assets/image/problem2.png'),
      problem3: require('@/assets/image/problem3.png'),
      problem4: require('@/assets/image/problem4.png'),
      appIcon: require('@/assets/image/appIcon.png'),
    },
    date: null,
    menus:[{name:'Windows'},{name:'Mac'}],
    // menus:[{name:'WindowsLink'},{name:'Windows'},{name:'Mac'}],
    currentMenuName:'',
  }),
  mounted(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{},
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-144 + 'px'}
    },
    redirectPath(path){
      this.$router.push(path)
    },
    selectMenu(menu){
      if(this.currentMenuName != menu.name)
        this.currentMenuName = menu.name
      else
        this.currentMenuName = ''
    },
    downloadLink(){
      window.location.href='https://exam.cerps.org.tw/study-0.0.1-SNAPSHOT/file/common/download?name=demo/CERPS專業認證考試.vbs';
      // https://exam.cerps.org.tw/study-0.0.1-SNAPSHOT/file/common/download?name=demo/CERPS%E5%B0%88%E6%A5%AD%E8%AA%8D%E8%AD%89%E8%80%83%E8%A9%A6.vbs
    },
    downloadWindows(){
      window.location.href='https://exam.cerps.org.tw/study-0.0.1-SNAPSHOT/file/common/download?name=demo/遠距考試工具.exe';
    },
    downloadMac(){
      // window.location.href='https://exam.cerps.org.tw/study-0.0.1-SNAPSHOT/file/common/download?name=demo/遠距考試工具.dmg';
      window.location.href='https://exam.cerps.org.tw/study-0.0.1-SNAPSHOT/file/common/download?name=demo/新版遠距考試工具.dmg';
    }
  }
}
</script>
